import { Flex, Grid, GridItem, Skeleton, Stack, StackItem } from "@patternfly/react-core";
import { useQuery } from "@tanstack/react-query";
import { getProductNameByOrgIdQuery } from "../../../../api/pyxis";
import SoftwareCodeIcon from "../../../../assets/software-code-red.svg";
import type { IActiveProductDetails } from "../../../../constants/apiconstants-pyxis";
import type { DragHandleProps } from "../../../../constants/CardsStructure";
import type { IPaginationRequest } from "../../../../constants/pagination";
import { getOrgID } from "../../../../utils/fetch";
import { NestedDashBoardCard } from "../../shared/NestedDashBoardCard";
import ActiveProductsCard from "./ActiveProductsCard";
import CertifySoftwareCard from "./CertifySoftwareCard";

const SkeletonActiveProductsCard = ({ dragHandleProps }: { dragHandleProps?: DragHandleProps | undefined }) => (
	<NestedDashBoardCard
		title="Software products"
		logo={SoftwareCodeIcon}
		dragHandleProps={dragHandleProps}
		bodyNode={
			<Grid hasGutter style={{ minHeight: "21em" }}>
				<GridItem span={3}>
					<Stack hasGutter>
						<StackItem>
							<Skeleton height="100%" />
						</StackItem>
						<StackItem>
							<Skeleton height="100%" />
						</StackItem>
					</Stack>
				</GridItem>
				<GridItem span={9}>
					<Stack hasGutter>
						<StackItem>
							<Skeleton width="31%" height="100%" />
						</StackItem>
						<StackItem>
							<Flex style={{ height: "12rem" }} flex={{ default: "flex_3" }}>
								<Skeleton height="100%" width="31%" />
								<Skeleton height="100%" width="31%" />
								<Skeleton height="100%" width="31%" />
							</Flex>
						</StackItem>
					</Stack>
				</GridItem>
			</Grid>
		}
		footerNode={
			<Flex direction={{ default: "row" }} flex={{ default: "flex_2" }}>
				<Skeleton width="15%" height="100%" />
				<Skeleton width="15%" height="100%" />
			</Flex>
		}
	/>
);

const ProductsCard = ({ dragHandleProps }: { dragHandleProps?: DragHandleProps | undefined }) => {
	const orgId = getOrgID();
	const PaginationState: IPaginationRequest = { page: 0, page_size: 3 };
	const { data, isLoading } = useQuery<IActiveProductDetails>({
		queryKey: ["productList"],
		queryFn: async ({ signal }) => await getProductNameByOrgIdQuery(orgId, PaginationState, signal),
	});

	if (isLoading) return <SkeletonActiveProductsCard dragHandleProps={dragHandleProps} />;
	if (data?.data?.unfinishedProducts?.data?.length === 0 && data?.data?.publishedProducts?.data?.length === 0) {
		return <CertifySoftwareCard />;
	}
	return (
		<ActiveProductsCard
			activeKey={data?.data?.unfinishedProducts?.data?.length ? 0 : 1}
			dragHandleProps={dragHandleProps}
		/>
	);
};

export default ProductsCard;
